import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = {
  class: "h-10 w-10 text-negative",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = { class: "m-0 text-sm text-textPrimary" }
const _hoisted_7 = ["title"]

import { onBeforeUnmount, ref, watch } from 'vue'
import { mdiAlertCircleOutline } from '@mdi/js'

import Network from '@/Network'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import StepPreview from '@/components/designSystem/modals/AttendanceUploadModal/StepPreview.vue'
import type { StationLegKey } from '@/types/station-evidence.types'
import { getApiErrorMessage } from '@/utils/apiError'


export default /*#__PURE__*/_defineComponent({
  __name: 'StationSheetEvidencePanel',
  props: {
    containerId: {},
    leg: {},
    testidPrefix: { default: 'station-evidence' }
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(false)
const loadError = ref<string | null>(null)
const fileUrl = ref<string | null>(null)
const fileType = ref<string | undefined>(undefined)
const fileName = ref('Folha de monitoramento.pdf')
// `rotation`/`zoom` do `StepPreview` são props CONTROLADAS: sem estes refs o
// botão de girar não gira.
const rotation = ref(0)
const zoom = ref(1)

/** `blob:` fica preso à aba até ser revogado — a folha pode ter dezenas de MB. */
function revoke() {
  if (fileUrl.value?.startsWith('blob:')) URL.revokeObjectURL(fileUrl.value)
  fileUrl.value = null
}

async function load() {
  const containerId = props.containerId
  if (containerId == null) return

  revoke()
  isLoading.value = true
  loadError.value = null
  rotation.value = 0
  zoom.value = 1
  try {
    // O nome do arquivo é acessório: se o detalhe falhar, o preview ainda vale.
    const [blob, detail] = await Promise.all([
      Network.dsAttendance.downloadEvidenceFile(containerId),
      Network.dsAttendance.getById(containerId).catch(() => null)
    ])
    if (containerId !== props.containerId) return
    fileUrl.value = URL.createObjectURL(blob)
    fileType.value = blob.type
    fileName.value = detail?.sheetFilename || 'Folha de monitoramento.pdf'
  } catch (error) {
    console.error('Erro ao buscar a folha de presença do plantão:', error)
    if (containerId === props.containerId) {
      loadError.value = getApiErrorMessage(error, 'Não foi possível carregar a página da folha.')
    }
  } finally {
    if (containerId === props.containerId) isLoading.value = false
  }
}

watch(
  () => props.containerId,
  () => void load(),
  { immediate: true }
)

onBeforeUnmount(revoke)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col gap-2 text-left",
    "data-testid": `${_ctx.testidPrefix}-sheet-${_ctx.leg}`
  }, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "min-h-[300px] w-full animate-pulse rounded-lg bg-lightGray30",
          "data-testid": `${_ctx.testidPrefix}-sheet-${_ctx.leg}-loading`
        }, null, 8, _hoisted_2))
      : (loadError.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "flex min-h-[240px] w-full flex-col items-center justify-center gap-3 rounded-lg border border-gray-200 p-6 text-center",
            "data-testid": `${_ctx.testidPrefix}-sheet-${_ctx.leg}-error`,
            role: "alert"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [
              _createElementVNode("path", {
                d: _unref(mdiAlertCircleOutline),
                fill: "currentColor"
              }, null, 8, _hoisted_5)
            ])),
            _createElementVNode("p", _hoisted_6, _toDisplayString(loadError.value), 1),
            _createVNode(OutlineButton, {
              text: "Tentar novamente",
              width: "200px",
              "data-testid": `${_ctx.testidPrefix}-sheet-${_ctx.leg}-retry-button`,
              onClick: load
            }, null, 8, ["data-testid"])
          ], 8, _hoisted_3))
        : (fileUrl.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(StepPreview, {
                file: null,
                "file-url": fileUrl.value,
                "file-type": fileType.value,
                rotation: rotation.value,
                zoom: zoom.value,
                mode: "preview",
                "show-display-name": false,
                "onUpdate:rotation": _cache[0] || (_cache[0] = ($event: any) => (rotation.value = $event)),
                "onUpdate:zoom": _cache[1] || (_cache[1] = ($event: any) => (zoom.value = $event))
              }, null, 8, ["file-url", "file-type", "rotation", "zoom"]),
              _createElementVNode("p", {
                class: "m-0 truncate text-xs text-neutral50",
                title: fileName.value
              }, _toDisplayString(fileName.value), 9, _hoisted_7)
            ], 64))
          : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})